// extracted by mini-css-extract-plugin
export default {"root":"GeneralInfoCard_root__WZGTn","section":"GeneralInfoCard_section__4diNg","tooltipIcon":"GeneralInfoCard_tooltipIcon__Ee+DL"};